
import { EditorValidator } from "slickgrid-react";
import Contractor from ".";
import  { CardFormEdit , CardEditorState} from "./editform";
import ContractorService from "../../services/contractor/contractor.service";
import * as React from 'react';
import { SyntheticEvent } from "react";



export default class CardEditorValidators{
    sender: CardFormEdit;
    constructor(s: CardFormEdit) {
     // super(sender);
        this.sender = s  
     }



 

    onPlanGroupChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), plangroupname : event.target.value},
        alertError: ""
      }))
    }

    onNameChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), name : event.target.value},
        alertError: ""
      }))
    }

    onListingDateChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_listingdate : event.target.value},
        alertError: ""
      }))
    }
    onNote1Change(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), note1 : event.target.value},
        alertError: ""
      }))
    }

    onCheckingDateChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_checkingdate : event.target.value},
        alertError: ""
      }))
    }

    onConstructionDateChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_constructiondate : event.target.value},
        alertError: ""
      }))
    }
    onNote2Change(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), note2 : event.target.value},
        alertError: ""
      }))
    }

    onDatechange(tmp: Date | null, event: SyntheticEvent<any, Event> | undefined) {

      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), date: tmp ==null ? 0 : tmp.getTime() },
        alertError: ""
      }))
    }

    onFairDataChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_fairdate : event.target.value},
        alertError: ""
      }))
    }

    onObjectNameChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_objectname : event.target.value},
        alertError: ""
      }))
    }

    onObjectAddressChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_objectaddress : event.target.value},
        alertError: ""
      }))
    }

    onComponentgraphicsDateChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_componentgraphicsdate : event.target.value},
        alertError: ""
      }))
    }

    onReadygraphicsDateChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_readygraphicsdate : event.target.value},
        alertError: ""
      }))
    }

    onComponentpresentationDateChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_componentpresentationdate: event.target.value},
        alertError: ""
      }))
    }

    onDisassemblyBuiltstandChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_disassemblybuiltstand: event.target.value},
        alertError: ""
      }))
    }

    onOtherCommentsChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_othercomments: event.target.value},
        alertError: ""
      }))
    }

    onParkrulesChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), parkrules: event.target.value},
        alertError: ""
      }))
    }

    onDisassemblystandChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_disassemblystand: event.target.value},
        alertError: ""
      }))
    }

    onInsertDateChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_insertsdate: event.target.value},
        alertError: ""
      }))
    }

    onReadypresentationDateChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_readypresentationdate: event.target.value},
        alertError: ""
      }))
    }

    onVisitorOpenHoursChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_visitoropeninghours : event.target.value},
        alertError: ""
      }))
    }

    onContactPersonChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_contactperson : event.target.value},
        alertError: ""
      }))
    }

    onExhibitorOpenHoursChange(event: { target: any}) {
      this.sender.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_exhibitoropeninghours : event.target.value},
        alertError: ""
      }))
    }



}